const vr = "Something went wrong. Please try again", wr = "It seems you don't have an internet connection. Please ensure you're connected to the internet.", br = "Something went wrong. You might be using Opera Mini or Opera Mobile with Data Saver option on. Please turn it off and try again.", Sr = "We can't process this action, you might be signed out. Please log in again.", Or = "We can't process this action, you don't have the required permissions.", Pr = "Your session has expired. Please log in again.", Er = (t) => [!1, t.message, -1], Mr = () => [!1, wr], Ar = (t, e) => {
  const r = t.data && t.data.error ? t.data.error : e;
  return [t.status, r];
}, ie = (t, e) => e && e.status === t, Dr = () => {
  const t = navigator.userAgent.toLowerCase();
  return t.includes("opr") || t.includes("opera");
}, xr = () => [br], Fr = () => [!1, Sr], Tr = () => [!1, Or], Ir = () => [!1, Pr], Nr = () => [!1], yi = ({ error: t, errorClientCallback: e, defaultErrorMessage: r }) => {
  let n = null, a = !0, o = r || vr;
  !t.request && !t.response && ([a, o, n] = Er(t));
  const { response: i, request: c } = t;
  return c && !i && ([a, o] = Mr()), i && ([n, o] = Ar(i, o), ie(400, i) && Dr() && ([o] = xr()), ie(401, i) && ([a, o] = Fr()), ie(403, i) && ([a, o] = Tr()), ie(422, i) && ([a, o] = Ir()), ie(404, i) && ([a] = Nr())), e && a && e(), { error: o, original: t, status: n };
}, pi = (t, e) => {
  var r;
  (r = window == null ? void 0 : window.analytics) == null || r.track(t, e, {
    integrations: { Intercom: !1 }
  });
};
var $r = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Rr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Wr(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var _r = Error, kr = EvalError, Cr = RangeError, Br = ReferenceError, Lt = SyntaxError, me = TypeError, Yr = URIError, Lr = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var a = 42;
  e[r] = a;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(e);
  if (o.length !== 1 || o[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var i = Object.getOwnPropertyDescriptor(e, r);
    if (i.value !== a || i.enumerable !== !0)
      return !1;
  }
  return !0;
}, ft = typeof Symbol < "u" && Symbol, Gr = Lr, qr = function() {
  return typeof ft != "function" || typeof Symbol != "function" || typeof ft("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Gr();
}, Re = {
  __proto__: null,
  foo: {}
}, Ur = Object, Hr = function() {
  return { __proto__: Re }.foo === Re.foo && !(Re instanceof Ur);
}, Qr = "Function.prototype.bind called on incompatible ", Vr = Object.prototype.toString, jr = Math.max, zr = "[object Function]", lt = function(e, r) {
  for (var n = [], a = 0; a < e.length; a += 1)
    n[a] = e[a];
  for (var o = 0; o < r.length; o += 1)
    n[o + e.length] = r[o];
  return n;
}, Jr = function(e, r) {
  for (var n = [], a = r, o = 0; a < e.length; a += 1, o += 1)
    n[o] = e[a];
  return n;
}, Xr = function(t, e) {
  for (var r = "", n = 0; n < t.length; n += 1)
    r += t[n], n + 1 < t.length && (r += e);
  return r;
}, Kr = function(e) {
  var r = this;
  if (typeof r != "function" || Vr.apply(r) !== zr)
    throw new TypeError(Qr + r);
  for (var n = Jr(arguments, 1), a, o = function() {
    if (this instanceof a) {
      var s = r.apply(
        this,
        lt(n, arguments)
      );
      return Object(s) === s ? s : this;
    }
    return r.apply(
      e,
      lt(n, arguments)
    );
  }, i = jr(0, r.length - n.length), c = [], u = 0; u < i; u++)
    c[u] = "$" + u;
  if (a = Function("binder", "return function (" + Xr(c, ",") + "){ return binder.apply(this,arguments); }")(o), r.prototype) {
    var f = function() {
    };
    f.prototype = r.prototype, a.prototype = new f(), f.prototype = null;
  }
  return a;
}, Zr = Kr, et = Function.prototype.bind || Zr, en = Function.prototype.call, tn = Object.prototype.hasOwnProperty, rn = et, nn = rn.call(en, tn), h, an = _r, on = kr, un = Cr, cn = Br, Z = Lt, K = me, sn = Yr, Gt = Function, We = function(t) {
  try {
    return Gt('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, U = Object.getOwnPropertyDescriptor;
if (U)
  try {
    U({}, "");
  } catch {
    U = null;
  }
var _e = function() {
  throw new K();
}, fn = U ? function() {
  try {
    return arguments.callee, _e;
  } catch {
    try {
      return U(arguments, "callee").get;
    } catch {
      return _e;
    }
  }
}() : _e, j = qr(), ln = Hr(), P = Object.getPrototypeOf || (ln ? function(t) {
  return t.__proto__;
} : null), X = {}, dn = typeof Uint8Array > "u" || !P ? h : P(Uint8Array), H = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? h : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? h : ArrayBuffer,
  "%ArrayIteratorPrototype%": j && P ? P([][Symbol.iterator]()) : h,
  "%AsyncFromSyncIteratorPrototype%": h,
  "%AsyncFunction%": X,
  "%AsyncGenerator%": X,
  "%AsyncGeneratorFunction%": X,
  "%AsyncIteratorPrototype%": X,
  "%Atomics%": typeof Atomics > "u" ? h : Atomics,
  "%BigInt%": typeof BigInt > "u" ? h : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? h : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? h : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? h : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": an,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": on,
  "%Float32Array%": typeof Float32Array > "u" ? h : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? h : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? h : FinalizationRegistry,
  "%Function%": Gt,
  "%GeneratorFunction%": X,
  "%Int8Array%": typeof Int8Array > "u" ? h : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? h : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? h : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": j && P ? P(P([][Symbol.iterator]())) : h,
  "%JSON%": typeof JSON == "object" ? JSON : h,
  "%Map%": typeof Map > "u" ? h : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !j || !P ? h : P((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? h : Promise,
  "%Proxy%": typeof Proxy > "u" ? h : Proxy,
  "%RangeError%": un,
  "%ReferenceError%": cn,
  "%Reflect%": typeof Reflect > "u" ? h : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? h : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !j || !P ? h : P((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? h : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": j && P ? P(""[Symbol.iterator]()) : h,
  "%Symbol%": j ? Symbol : h,
  "%SyntaxError%": Z,
  "%ThrowTypeError%": fn,
  "%TypedArray%": dn,
  "%TypeError%": K,
  "%Uint8Array%": typeof Uint8Array > "u" ? h : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? h : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? h : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? h : Uint32Array,
  "%URIError%": sn,
  "%WeakMap%": typeof WeakMap > "u" ? h : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? h : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? h : WeakSet
};
if (P)
  try {
    null.error;
  } catch (t) {
    var yn = P(P(t));
    H["%Error.prototype%"] = yn;
  }
var pn = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = We("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = We("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = We("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var a = t("%AsyncGenerator%");
    a && P && (r = P(a.prototype));
  }
  return H[e] = r, r;
}, dt = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, he = et, Me = nn, mn = he.call(Function.call, Array.prototype.concat), hn = he.call(Function.apply, Array.prototype.splice), yt = he.call(Function.call, String.prototype.replace), Ae = he.call(Function.call, String.prototype.slice), gn = he.call(Function.call, RegExp.prototype.exec), vn = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, wn = /\\(\\)?/g, bn = function(e) {
  var r = Ae(e, 0, 1), n = Ae(e, -1);
  if (r === "%" && n !== "%")
    throw new Z("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Z("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return yt(e, vn, function(o, i, c, u) {
    a[a.length] = c ? yt(u, wn, "$1") : i || o;
  }), a;
}, Sn = function(e, r) {
  var n = e, a;
  if (Me(dt, n) && (a = dt[n], n = "%" + a[0] + "%"), Me(H, n)) {
    var o = H[n];
    if (o === X && (o = pn(n)), typeof o > "u" && !r)
      throw new K("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: n,
      value: o
    };
  }
  throw new Z("intrinsic " + e + " does not exist!");
}, re = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new K("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new K('"allowMissing" argument must be a boolean');
  if (gn(/^%?[^%]*%?$/, e) === null)
    throw new Z("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = bn(e), a = n.length > 0 ? n[0] : "", o = Sn("%" + a + "%", r), i = o.name, c = o.value, u = !1, f = o.alias;
  f && (a = f[0], hn(n, mn([0, 1], f)));
  for (var s = 1, d = !0; s < n.length; s += 1) {
    var l = n[s], m = Ae(l, 0, 1), p = Ae(l, -1);
    if ((m === '"' || m === "'" || m === "`" || p === '"' || p === "'" || p === "`") && m !== p)
      throw new Z("property names with quotes must have matching quotes");
    if ((l === "constructor" || !d) && (u = !0), a += "." + l, i = "%" + a + "%", Me(H, i))
      c = H[i];
    else if (c != null) {
      if (!(l in c)) {
        if (!r)
          throw new K("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (U && s + 1 >= n.length) {
        var y = U(c, l);
        d = !!y, d && "get" in y && !("originalValue" in y.get) ? c = y.get : c = c[l];
      } else
        d = Me(c, l), c = c[l];
      d && !u && (H[i] = c);
    }
  }
  return c;
}, qt = { exports: {} }, ke, pt;
function tt() {
  if (pt) return ke;
  pt = 1;
  var t = re, e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return ke = e, ke;
}
var On = re, Pe = On("%Object.getOwnPropertyDescriptor%", !0);
if (Pe)
  try {
    Pe([], "length");
  } catch {
    Pe = null;
  }
var Ut = Pe, mt = tt(), Pn = Lt, z = me, ht = Ut, En = function(e, r, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new z("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new z("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new z("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new z("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new z("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new z("`loose`, if provided, must be a boolean");
  var a = arguments.length > 3 ? arguments[3] : null, o = arguments.length > 4 ? arguments[4] : null, i = arguments.length > 5 ? arguments[5] : null, c = arguments.length > 6 ? arguments[6] : !1, u = !!ht && ht(e, r);
  if (mt)
    mt(e, r, {
      configurable: i === null && u ? u.configurable : !i,
      enumerable: a === null && u ? u.enumerable : !a,
      value: n,
      writable: o === null && u ? u.writable : !o
    });
  else if (c || !a && !o && !i)
    e[r] = n;
  else
    throw new Pn("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Ve = tt(), Ht = function() {
  return !!Ve;
};
Ht.hasArrayLengthDefineBug = function() {
  if (!Ve)
    return null;
  try {
    return Ve([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Mn = Ht, An = re, gt = En, Dn = Mn(), vt = Ut, wt = me, xn = An("%Math.floor%"), Fn = function(e, r) {
  if (typeof e != "function")
    throw new wt("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || xn(r) !== r)
    throw new wt("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], a = !0, o = !0;
  if ("length" in e && vt) {
    var i = vt(e, "length");
    i && !i.configurable && (a = !1), i && !i.writable && (o = !1);
  }
  return (a || o || !n) && (Dn ? gt(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r,
    !0,
    !0
  ) : gt(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r
  )), e;
};
(function(t) {
  var e = et, r = re, n = Fn, a = me, o = r("%Function.prototype.apply%"), i = r("%Function.prototype.call%"), c = r("%Reflect.apply%", !0) || e.call(i, o), u = tt(), f = r("%Math.max%");
  t.exports = function(l) {
    if (typeof l != "function")
      throw new a("a function is required");
    var m = c(e, i, arguments);
    return n(
      m,
      1 + f(0, l.length - (arguments.length - 1)),
      !0
    );
  };
  var s = function() {
    return c(e, o, arguments);
  };
  u ? u(t.exports, "apply", { value: s }) : t.exports.apply = s;
})(qt);
var Tn = qt.exports, Qt = re, Vt = Tn, In = Vt(Qt("String.prototype.indexOf")), Nn = function(e, r) {
  var n = Qt(e, !!r);
  return typeof n == "function" && In(e, ".prototype.") > -1 ? Vt(n) : n;
};
const $n = {}, Rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $n
}, Symbol.toStringTag, { value: "Module" })), Wn = /* @__PURE__ */ Wr(Rn);
var rt = typeof Map == "function" && Map.prototype, Ce = Object.getOwnPropertyDescriptor && rt ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, De = rt && Ce && typeof Ce.get == "function" ? Ce.get : null, bt = rt && Map.prototype.forEach, nt = typeof Set == "function" && Set.prototype, Be = Object.getOwnPropertyDescriptor && nt ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, xe = nt && Be && typeof Be.get == "function" ? Be.get : null, St = nt && Set.prototype.forEach, _n = typeof WeakMap == "function" && WeakMap.prototype, fe = _n ? WeakMap.prototype.has : null, kn = typeof WeakSet == "function" && WeakSet.prototype, le = kn ? WeakSet.prototype.has : null, Cn = typeof WeakRef == "function" && WeakRef.prototype, Ot = Cn ? WeakRef.prototype.deref : null, Bn = Boolean.prototype.valueOf, Yn = Object.prototype.toString, Ln = Function.prototype.toString, Gn = String.prototype.match, at = String.prototype.slice, k = String.prototype.replace, qn = String.prototype.toUpperCase, Pt = String.prototype.toLowerCase, jt = RegExp.prototype.test, Et = Array.prototype.concat, x = Array.prototype.join, Un = Array.prototype.slice, Mt = Math.floor, je = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Ye = Object.getOwnPropertySymbols, ze = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ee = typeof Symbol == "function" && typeof Symbol.iterator == "object", E = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ee || !0) ? Symbol.toStringTag : null, zt = Object.prototype.propertyIsEnumerable, At = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function Dt(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || jt.call(/e/, e))
    return e;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var n = t < 0 ? -Mt(-t) : Mt(t);
    if (n !== t) {
      var a = String(n), o = at.call(e, a.length + 1);
      return k.call(a, r, "$&_") + "." + k.call(k.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return k.call(e, r, "$&_");
}
var Je = Wn, xt = Je.custom, Ft = Xt(xt) ? xt : null, Hn = function t(e, r, n, a) {
  var o = r || {};
  if (_(o, "quoteStyle") && o.quoteStyle !== "single" && o.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (_(o, "maxStringLength") && (typeof o.maxStringLength == "number" ? o.maxStringLength < 0 && o.maxStringLength !== 1 / 0 : o.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var i = _(o, "customInspect") ? o.customInspect : !0;
  if (typeof i != "boolean" && i !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (_(o, "indent") && o.indent !== null && o.indent !== "	" && !(parseInt(o.indent, 10) === o.indent && o.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (_(o, "numericSeparator") && typeof o.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var c = o.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return Zt(e, o);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var u = String(e);
    return c ? Dt(e, u) : u;
  }
  if (typeof e == "bigint") {
    var f = String(e) + "n";
    return c ? Dt(e, f) : f;
  }
  var s = typeof o.depth > "u" ? 5 : o.depth;
  if (typeof n > "u" && (n = 0), n >= s && s > 0 && typeof e == "object")
    return Xe(e) ? "[Array]" : "[Object]";
  var d = sa(o, n);
  if (typeof a > "u")
    a = [];
  else if (Kt(a, e) >= 0)
    return "[Circular]";
  function l(M, $, R) {
    if ($ && (a = Un.call(a), a.push($)), R) {
      var oe = {
        depth: o.depth
      };
      return _(o, "quoteStyle") && (oe.quoteStyle = o.quoteStyle), t(M, oe, n + 1, a);
    }
    return t(M, o, n + 1, a);
  }
  if (typeof e == "function" && !Tt(e)) {
    var m = ea(e), p = be(e, l);
    return "[Function" + (m ? ": " + m : " (anonymous)") + "]" + (p.length > 0 ? " { " + x.call(p, ", ") + " }" : "");
  }
  if (Xt(e)) {
    var y = ee ? k.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : ze.call(e);
    return typeof e == "object" && !ee ? ue(y) : y;
  }
  if (ia(e)) {
    for (var v = "<" + Pt.call(String(e.nodeName)), F = e.attributes || [], T = 0; T < F.length; T++)
      v += " " + F[T].name + "=" + Jt(Qn(F[T].value), "double", o);
    return v += ">", e.childNodes && e.childNodes.length && (v += "..."), v += "</" + Pt.call(String(e.nodeName)) + ">", v;
  }
  if (Xe(e)) {
    if (e.length === 0)
      return "[]";
    var g = be(e, l);
    return d && !ca(g) ? "[" + Ke(g, d) + "]" : "[ " + x.call(g, ", ") + " ]";
  }
  if (jn(e)) {
    var I = be(e, l);
    return !("cause" in Error.prototype) && "cause" in e && !zt.call(e, "cause") ? "{ [" + String(e) + "] " + x.call(Et.call("[cause]: " + l(e.cause), I), ", ") + " }" : I.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + x.call(I, ", ") + " }";
  }
  if (typeof e == "object" && i) {
    if (Ft && typeof e[Ft] == "function" && Je)
      return Je(e, { depth: s - n });
    if (i !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (ta(e)) {
    var Y = [];
    return bt && bt.call(e, function(M, $) {
      Y.push(l($, e, !0) + " => " + l(M, e));
    }), It("Map", De.call(e), Y, d);
  }
  if (aa(e)) {
    var ae = [];
    return St && St.call(e, function(M) {
      ae.push(l(M, e));
    }), It("Set", xe.call(e), ae, d);
  }
  if (ra(e))
    return Le("WeakMap");
  if (oa(e))
    return Le("WeakSet");
  if (na(e))
    return Le("WeakRef");
  if (Jn(e))
    return ue(l(Number(e)));
  if (Kn(e))
    return ue(l(je.call(e)));
  if (Xn(e))
    return ue(Bn.call(e));
  if (zn(e))
    return ue(l(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (e === $r)
    return "{ [object globalThis] }";
  if (!Vn(e) && !Tt(e)) {
    var Q = be(e, l), ve = At ? At(e) === Object.prototype : e instanceof Object || e.constructor === Object, L = e instanceof Object ? "" : "null prototype", N = !ve && E && Object(e) === e && E in e ? at.call(B(e), 8, -1) : L ? "Object" : "", we = ve || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", V = we + (N || L ? "[" + x.call(Et.call([], N || [], L || []), ": ") + "] " : "");
    return Q.length === 0 ? V + "{}" : d ? V + "{" + Ke(Q, d) + "}" : V + "{ " + x.call(Q, ", ") + " }";
  }
  return String(e);
};
function Jt(t, e, r) {
  var n = (r.quoteStyle || e) === "double" ? '"' : "'";
  return n + t + n;
}
function Qn(t) {
  return k.call(String(t), /"/g, "&quot;");
}
function Xe(t) {
  return B(t) === "[object Array]" && (!E || !(typeof t == "object" && E in t));
}
function Vn(t) {
  return B(t) === "[object Date]" && (!E || !(typeof t == "object" && E in t));
}
function Tt(t) {
  return B(t) === "[object RegExp]" && (!E || !(typeof t == "object" && E in t));
}
function jn(t) {
  return B(t) === "[object Error]" && (!E || !(typeof t == "object" && E in t));
}
function zn(t) {
  return B(t) === "[object String]" && (!E || !(typeof t == "object" && E in t));
}
function Jn(t) {
  return B(t) === "[object Number]" && (!E || !(typeof t == "object" && E in t));
}
function Xn(t) {
  return B(t) === "[object Boolean]" && (!E || !(typeof t == "object" && E in t));
}
function Xt(t) {
  if (ee)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !ze)
    return !1;
  try {
    return ze.call(t), !0;
  } catch {
  }
  return !1;
}
function Kn(t) {
  if (!t || typeof t != "object" || !je)
    return !1;
  try {
    return je.call(t), !0;
  } catch {
  }
  return !1;
}
var Zn = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function _(t, e) {
  return Zn.call(t, e);
}
function B(t) {
  return Yn.call(t);
}
function ea(t) {
  if (t.name)
    return t.name;
  var e = Gn.call(Ln.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function Kt(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function ta(t) {
  if (!De || !t || typeof t != "object")
    return !1;
  try {
    De.call(t);
    try {
      xe.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function ra(t) {
  if (!fe || !t || typeof t != "object")
    return !1;
  try {
    fe.call(t, fe);
    try {
      le.call(t, le);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function na(t) {
  if (!Ot || !t || typeof t != "object")
    return !1;
  try {
    return Ot.call(t), !0;
  } catch {
  }
  return !1;
}
function aa(t) {
  if (!xe || !t || typeof t != "object")
    return !1;
  try {
    xe.call(t);
    try {
      De.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function oa(t) {
  if (!le || !t || typeof t != "object")
    return !1;
  try {
    le.call(t, le);
    try {
      fe.call(t, fe);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function ia(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function Zt(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return Zt(at.call(t, 0, e.maxStringLength), e) + n;
  }
  var a = k.call(k.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, ua);
  return Jt(a, "single", e);
}
function ua(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + qn.call(e.toString(16));
}
function ue(t) {
  return "Object(" + t + ")";
}
function Le(t) {
  return t + " { ? }";
}
function It(t, e, r, n) {
  var a = n ? Ke(r, n) : x.call(r, ", ");
  return t + " (" + e + ") {" + a + "}";
}
function ca(t) {
  for (var e = 0; e < t.length; e++)
    if (Kt(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function sa(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = x.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: x.call(Array(e + 1), r)
  };
}
function Ke(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + x.call(t, "," + r) + `
` + e.prev;
}
function be(t, e) {
  var r = Xe(t), n = [];
  if (r) {
    n.length = t.length;
    for (var a = 0; a < t.length; a++)
      n[a] = _(t, a) ? e(t[a], t) : "";
  }
  var o = typeof Ye == "function" ? Ye(t) : [], i;
  if (ee) {
    i = {};
    for (var c = 0; c < o.length; c++)
      i["$" + o[c]] = o[c];
  }
  for (var u in t)
    _(t, u) && (r && String(Number(u)) === u && u < t.length || ee && i["$" + u] instanceof Symbol || (jt.call(/[^\w$]/, u) ? n.push(e(u, t) + ": " + e(t[u], t)) : n.push(u + ": " + e(t[u], t))));
  if (typeof Ye == "function")
    for (var f = 0; f < o.length; f++)
      zt.call(t, o[f]) && n.push("[" + e(o[f]) + "]: " + e(t[o[f]], t));
  return n;
}
var er = re, ne = Nn, fa = Hn, la = me, Se = er("%WeakMap%", !0), Oe = er("%Map%", !0), da = ne("WeakMap.prototype.get", !0), ya = ne("WeakMap.prototype.set", !0), pa = ne("WeakMap.prototype.has", !0), ma = ne("Map.prototype.get", !0), ha = ne("Map.prototype.set", !0), ga = ne("Map.prototype.has", !0), ot = function(t, e) {
  for (var r = t, n; (n = r.next) !== null; r = n)
    if (n.key === e)
      return r.next = n.next, n.next = /** @type {NonNullable<typeof list.next>} */
      t.next, t.next = n, n;
}, va = function(t, e) {
  var r = ot(t, e);
  return r && r.value;
}, wa = function(t, e, r) {
  var n = ot(t, e);
  n ? n.value = r : t.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: e,
    next: t.next,
    value: r
  };
}, ba = function(t, e) {
  return !!ot(t, e);
}, Sa = function() {
  var e, r, n, a = {
    assert: function(o) {
      if (!a.has(o))
        throw new la("Side channel does not contain " + fa(o));
    },
    get: function(o) {
      if (Se && o && (typeof o == "object" || typeof o == "function")) {
        if (e)
          return da(e, o);
      } else if (Oe) {
        if (r)
          return ma(r, o);
      } else if (n)
        return va(n, o);
    },
    has: function(o) {
      if (Se && o && (typeof o == "object" || typeof o == "function")) {
        if (e)
          return pa(e, o);
      } else if (Oe) {
        if (r)
          return ga(r, o);
      } else if (n)
        return ba(n, o);
      return !1;
    },
    set: function(o, i) {
      Se && o && (typeof o == "object" || typeof o == "function") ? (e || (e = new Se()), ya(e, o, i)) : Oe ? (r || (r = new Oe()), ha(r, o, i)) : (n || (n = { key: {}, next: null }), wa(n, o, i));
    }
  };
  return a;
}, Oa = String.prototype.replace, Pa = /%20/g, Ge = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, it = {
  default: Ge.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return Oa.call(t, Pa, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: Ge.RFC1738,
  RFC3986: Ge.RFC3986
}, Ea = it, qe = Object.prototype.hasOwnProperty, q = Array.isArray, A = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), Ma = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), n = r.obj[r.prop];
    if (q(n)) {
      for (var a = [], o = 0; o < n.length; ++o)
        typeof n[o] < "u" && a.push(n[o]);
      r.obj[r.prop] = a;
    }
  }
}, tr = function(e, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < e.length; ++a)
    typeof e[a] < "u" && (n[a] = e[a]);
  return n;
}, Aa = function t(e, r, n) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (q(e))
      e.push(r);
    else if (e && typeof e == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !qe.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var a = e;
  return q(e) && !q(r) && (a = tr(e, n)), q(e) && q(r) ? (r.forEach(function(o, i) {
    if (qe.call(e, i)) {
      var c = e[i];
      c && typeof c == "object" && o && typeof o == "object" ? e[i] = t(c, o, n) : e.push(o);
    } else
      e[i] = o;
  }), e) : Object.keys(r).reduce(function(o, i) {
    var c = r[i];
    return qe.call(o, i) ? o[i] = t(o[i], c, n) : o[i] = c, o;
  }, a);
}, Da = function(e, r) {
  return Object.keys(r).reduce(function(n, a) {
    return n[a] = r[a], n;
  }, e);
}, xa = function(t, e, r) {
  var n = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, Ue = 1024, Fa = function(e, r, n, a, o) {
  if (e.length === 0)
    return e;
  var i = e;
  if (typeof e == "symbol" ? i = Symbol.prototype.toString.call(e) : typeof e != "string" && (i = String(e)), n === "iso-8859-1")
    return escape(i).replace(/%u[0-9a-f]{4}/gi, function(m) {
      return "%26%23" + parseInt(m.slice(2), 16) + "%3B";
    });
  for (var c = "", u = 0; u < i.length; u += Ue) {
    for (var f = i.length >= Ue ? i.slice(u, u + Ue) : i, s = [], d = 0; d < f.length; ++d) {
      var l = f.charCodeAt(d);
      if (l === 45 || l === 46 || l === 95 || l === 126 || l >= 48 && l <= 57 || l >= 65 && l <= 90 || l >= 97 && l <= 122 || o === Ea.RFC1738 && (l === 40 || l === 41)) {
        s[s.length] = f.charAt(d);
        continue;
      }
      if (l < 128) {
        s[s.length] = A[l];
        continue;
      }
      if (l < 2048) {
        s[s.length] = A[192 | l >> 6] + A[128 | l & 63];
        continue;
      }
      if (l < 55296 || l >= 57344) {
        s[s.length] = A[224 | l >> 12] + A[128 | l >> 6 & 63] + A[128 | l & 63];
        continue;
      }
      d += 1, l = 65536 + ((l & 1023) << 10 | f.charCodeAt(d) & 1023), s[s.length] = A[240 | l >> 18] + A[128 | l >> 12 & 63] + A[128 | l >> 6 & 63] + A[128 | l & 63];
    }
    c += s.join("");
  }
  return c;
}, Ta = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], n = [], a = 0; a < r.length; ++a)
    for (var o = r[a], i = o.obj[o.prop], c = Object.keys(i), u = 0; u < c.length; ++u) {
      var f = c[u], s = i[f];
      typeof s == "object" && s !== null && n.indexOf(s) === -1 && (r.push({ obj: i, prop: f }), n.push(s));
    }
  return Ma(r), e;
}, Ia = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, Na = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, $a = function(e, r) {
  return [].concat(e, r);
}, Ra = function(e, r) {
  if (q(e)) {
    for (var n = [], a = 0; a < e.length; a += 1)
      n.push(r(e[a]));
    return n;
  }
  return r(e);
}, rr = {
  arrayToObject: tr,
  assign: Da,
  combine: $a,
  compact: Ta,
  decode: xa,
  encode: Fa,
  isBuffer: Na,
  isRegExp: Ia,
  maybeMap: Ra,
  merge: Aa
}, nr = Sa, Ee = rr, de = it, Wa = Object.prototype.hasOwnProperty, ar = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, D = Array.isArray, _a = Array.prototype.push, or = function(t, e) {
  _a.apply(t, D(e) ? e : [e]);
}, ka = Date.prototype.toISOString, Nt = de.default, O = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Ee.encode,
  encodeValuesOnly: !1,
  format: Nt,
  formatter: de.formatters[Nt],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return ka.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Ca = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, He = {}, Ba = function t(e, r, n, a, o, i, c, u, f, s, d, l, m, p, y, v, F, T) {
  for (var g = e, I = T, Y = 0, ae = !1; (I = I.get(He)) !== void 0 && !ae; ) {
    var Q = I.get(e);
    if (Y += 1, typeof Q < "u") {
      if (Q === Y)
        throw new RangeError("Cyclic object value");
      ae = !0;
    }
    typeof I.get(He) > "u" && (Y = 0);
  }
  if (typeof s == "function" ? g = s(r, g) : g instanceof Date ? g = m(g) : n === "comma" && D(g) && (g = Ee.maybeMap(g, function($e) {
    return $e instanceof Date ? m($e) : $e;
  })), g === null) {
    if (i)
      return f && !v ? f(r, O.encoder, F, "key", p) : r;
    g = "";
  }
  if (Ca(g) || Ee.isBuffer(g)) {
    if (f) {
      var ve = v ? r : f(r, O.encoder, F, "key", p);
      return [y(ve) + "=" + y(f(g, O.encoder, F, "value", p))];
    }
    return [y(r) + "=" + y(String(g))];
  }
  var L = [];
  if (typeof g > "u")
    return L;
  var N;
  if (n === "comma" && D(g))
    v && f && (g = Ee.maybeMap(g, f)), N = [{ value: g.length > 0 ? g.join(",") || null : void 0 }];
  else if (D(s))
    N = s;
  else {
    var we = Object.keys(g);
    N = d ? we.sort(d) : we;
  }
  var V = u ? r.replace(/\./g, "%2E") : r, M = a && D(g) && g.length === 1 ? V + "[]" : V;
  if (o && D(g) && g.length === 0)
    return M + "[]";
  for (var $ = 0; $ < N.length; ++$) {
    var R = N[$], oe = typeof R == "object" && typeof R.value < "u" ? R.value : g[R];
    if (!(c && oe === null)) {
      var Ne = l && u ? R.replace(/\./g, "%2E") : R, gr = D(g) ? typeof n == "function" ? n(M, Ne) : M : M + (l ? "." + Ne : "[" + Ne + "]");
      T.set(e, Y);
      var st = nr();
      st.set(He, T), or(L, t(
        oe,
        gr,
        n,
        a,
        o,
        i,
        c,
        u,
        n === "comma" && v && D(g) ? null : f,
        s,
        d,
        l,
        m,
        p,
        y,
        v,
        F,
        st
      ));
    }
  }
  return L;
}, Ya = function(e) {
  if (!e)
    return O;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || O.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = de.default;
  if (typeof e.format < "u") {
    if (!Wa.call(de.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    n = e.format;
  }
  var a = de.formatters[n], o = O.filter;
  (typeof e.filter == "function" || D(e.filter)) && (o = e.filter);
  var i;
  if (e.arrayFormat in ar ? i = e.arrayFormat : "indices" in e ? i = e.indices ? "indices" : "repeat" : i = O.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var c = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : O.allowDots : !!e.allowDots;
  return {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : O.addQueryPrefix,
    allowDots: c,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : O.allowEmptyArrays,
    arrayFormat: i,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : O.charsetSentinel,
    commaRoundTrip: e.commaRoundTrip,
    delimiter: typeof e.delimiter > "u" ? O.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : O.encode,
    encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : O.encodeDotInKeys,
    encoder: typeof e.encoder == "function" ? e.encoder : O.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : O.encodeValuesOnly,
    filter: o,
    format: n,
    formatter: a,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : O.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : O.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : O.strictNullHandling
  };
}, La = function(t, e) {
  var r = t, n = Ya(e), a, o;
  typeof n.filter == "function" ? (o = n.filter, r = o("", r)) : D(n.filter) && (o = n.filter, a = o);
  var i = [];
  if (typeof r != "object" || r === null)
    return "";
  var c = ar[n.arrayFormat], u = c === "comma" && n.commaRoundTrip;
  a || (a = Object.keys(r)), n.sort && a.sort(n.sort);
  for (var f = nr(), s = 0; s < a.length; ++s) {
    var d = a[s];
    n.skipNulls && r[d] === null || or(i, Ba(
      r[d],
      d,
      c,
      u,
      n.allowEmptyArrays,
      n.strictNullHandling,
      n.skipNulls,
      n.encodeDotInKeys,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      f
    ));
  }
  var l = i.join(n.delimiter), m = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? m += "utf8=%26%2310003%3B&" : m += "utf8=%E2%9C%93&"), l.length > 0 ? m + l : "";
}, te = rr, Ze = Object.prototype.hasOwnProperty, Ga = Array.isArray, S = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: te.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, qa = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, ir = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, Ua = "utf8=%26%2310003%3B", Ha = "utf8=%E2%9C%93", Qa = function(e, r) {
  var n = { __proto__: null }, a = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, o = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, i = a.split(r.delimiter, o), c = -1, u, f = r.charset;
  if (r.charsetSentinel)
    for (u = 0; u < i.length; ++u)
      i[u].indexOf("utf8=") === 0 && (i[u] === Ha ? f = "utf-8" : i[u] === Ua && (f = "iso-8859-1"), c = u, u = i.length);
  for (u = 0; u < i.length; ++u)
    if (u !== c) {
      var s = i[u], d = s.indexOf("]="), l = d === -1 ? s.indexOf("=") : d + 1, m, p;
      l === -1 ? (m = r.decoder(s, S.decoder, f, "key"), p = r.strictNullHandling ? null : "") : (m = r.decoder(s.slice(0, l), S.decoder, f, "key"), p = te.maybeMap(
        ir(s.slice(l + 1), r),
        function(v) {
          return r.decoder(v, S.decoder, f, "value");
        }
      )), p && r.interpretNumericEntities && f === "iso-8859-1" && (p = qa(p)), s.indexOf("[]=") > -1 && (p = Ga(p) ? [p] : p);
      var y = Ze.call(n, m);
      y && r.duplicates === "combine" ? n[m] = te.combine(n[m], p) : (!y || r.duplicates === "last") && (n[m] = p);
    }
  return n;
}, Va = function(t, e, r, n) {
  for (var a = n ? e : ir(e, r), o = t.length - 1; o >= 0; --o) {
    var i, c = t[o];
    if (c === "[]" && r.parseArrays)
      i = r.allowEmptyArrays && a === "" ? [] : [].concat(a);
    else {
      i = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var u = c.charAt(0) === "[" && c.charAt(c.length - 1) === "]" ? c.slice(1, -1) : c, f = r.decodeDotInKeys ? u.replace(/%2E/g, ".") : u, s = parseInt(f, 10);
      !r.parseArrays && f === "" ? i = { 0: a } : !isNaN(s) && c !== f && String(s) === f && s >= 0 && r.parseArrays && s <= r.arrayLimit ? (i = [], i[s] = a) : f !== "__proto__" && (i[f] = a);
    }
    a = i;
  }
  return a;
}, ja = function(e, r, n, a) {
  if (e) {
    var o = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, i = /(\[[^[\]]*])/, c = /(\[[^[\]]*])/g, u = n.depth > 0 && i.exec(o), f = u ? o.slice(0, u.index) : o, s = [];
    if (f) {
      if (!n.plainObjects && Ze.call(Object.prototype, f) && !n.allowPrototypes)
        return;
      s.push(f);
    }
    for (var d = 0; n.depth > 0 && (u = c.exec(o)) !== null && d < n.depth; ) {
      if (d += 1, !n.plainObjects && Ze.call(Object.prototype, u[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      s.push(u[1]);
    }
    return u && s.push("[" + o.slice(u.index) + "]"), Va(s, r, n, a);
  }
}, za = function(e) {
  if (!e)
    return S;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.decodeDotInKeys < "u" && typeof e.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.decoder !== null && typeof e.decoder < "u" && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? S.charset : e.charset, n = typeof e.duplicates > "u" ? S.duplicates : e.duplicates;
  if (n !== "combine" && n !== "first" && n !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var a = typeof e.allowDots > "u" ? e.decodeDotInKeys === !0 ? !0 : S.allowDots : !!e.allowDots;
  return {
    allowDots: a,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : S.allowEmptyArrays,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : S.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : S.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : S.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : S.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : S.comma,
    decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : S.decodeDotInKeys,
    decoder: typeof e.decoder == "function" ? e.decoder : S.decoder,
    delimiter: typeof e.delimiter == "string" || te.isRegExp(e.delimiter) ? e.delimiter : S.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : S.depth,
    duplicates: n,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : S.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : S.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : S.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : S.strictNullHandling
  };
}, Ja = function(t, e) {
  var r = za(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof t == "string" ? Qa(t, r) : t, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = Object.keys(n), i = 0; i < o.length; ++i) {
    var c = o[i], u = ja(c, n[c], r, typeof t == "string");
    a = te.merge(a, u, r);
  }
  return r.allowSparse === !0 ? a : te.compact(a);
}, Xa = La, Ka = Ja, Za = it, eo = {
  formats: Za,
  parse: Ka,
  stringify: Xa
};
const ur = /* @__PURE__ */ Rr(eo), mi = (t) => ur.parse(t, { arrayLimit: 50, ignoreQueryPrefix: !0 }), to = (t) => Object.keys(t).reduce((e, r) => t[r] ? { ...e, [r]: t[r] } : e, {}), hi = (t, e = {}) => ur.stringify(to(t), {
  encodeValuesOnly: !0,
  arrayFormat: "indices",
  ...e
});
function cr(t) {
  return (e) => {
    const n = (t ? Math[t] : Math.trunc)(e);
    return n === 0 ? 0 : n;
  };
}
function b(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function ro(t, e) {
  return +b(t) - +b(e);
}
function ut(t, e, r) {
  const n = ro(t, e) / 1e3;
  return cr(r == null ? void 0 : r.roundingMethod)(n);
}
const no = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ao = (t, e, r) => {
  let n;
  const a = no[t];
  return typeof a == "string" ? n = a : e === 1 ? n = a.one : n = a.other.replace("{{count}}", e.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Qe(t) {
  return (e = {}) => {
    const r = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[r] || t.formats[t.defaultWidth];
  };
}
const oo = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, io = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, uo = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, co = {
  date: Qe({
    formats: oo,
    defaultWidth: "full"
  }),
  time: Qe({
    formats: io,
    defaultWidth: "full"
  }),
  dateTime: Qe({
    formats: uo,
    defaultWidth: "full"
  })
}, so = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fo = (t, e, r, n) => so[t];
function ce(t) {
  return (e, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, c = r != null && r.width ? String(r.width) : i;
      a = t.formattingValues[c] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, c = r != null && r.width ? String(r.width) : t.defaultWidth;
      a = t.values[c] || t.values[i];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[o];
  };
}
const lo = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yo = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, po = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, mo = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ho = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, go = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, vo = (t, e) => {
  const r = Number(t), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, wo = {
  ordinalNumber: vo,
  era: ce({
    values: lo,
    defaultWidth: "wide"
  }),
  quarter: ce({
    values: yo,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: ce({
    values: po,
    defaultWidth: "wide"
  }),
  day: ce({
    values: mo,
    defaultWidth: "wide"
  }),
  dayPeriod: ce({
    values: ho,
    defaultWidth: "wide",
    formattingValues: go,
    defaultFormattingWidth: "wide"
  })
};
function se(t) {
  return (e, r = {}) => {
    const n = r.width, a = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], o = e.match(a);
    if (!o)
      return null;
    const i = o[0], c = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(c) ? So(c, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      bo(c, (d) => d.test(i))
    );
    let f;
    f = t.valueCallback ? t.valueCallback(u) : u, f = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(f)
    ) : f;
    const s = e.slice(i.length);
    return { value: f, rest: s };
  };
}
function bo(t, e) {
  for (const r in t)
    if (Object.prototype.hasOwnProperty.call(t, r) && e(t[r]))
      return r;
}
function So(t, e) {
  for (let r = 0; r < t.length; r++)
    if (e(t[r]))
      return r;
}
function Oo(t) {
  return (e, r = {}) => {
    const n = e.match(t.matchPattern);
    if (!n) return null;
    const a = n[0], o = e.match(t.parsePattern);
    if (!o) return null;
    let i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    const c = e.slice(a.length);
    return { value: i, rest: c };
  };
}
const Po = /^(\d+)(th|st|nd|rd)?/i, Eo = /\d+/i, Mo = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ao = {
  any: [/^b/i, /^(a|c)/i]
}, Do = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, xo = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Fo = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, To = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Io = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, No = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, $o = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ro = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Wo = {
  ordinalNumber: Oo({
    matchPattern: Po,
    parsePattern: Eo,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: se({
    matchPatterns: Mo,
    defaultMatchWidth: "wide",
    parsePatterns: Ao,
    defaultParseWidth: "any"
  }),
  quarter: se({
    matchPatterns: Do,
    defaultMatchWidth: "wide",
    parsePatterns: xo,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: se({
    matchPatterns: Fo,
    defaultMatchWidth: "wide",
    parsePatterns: To,
    defaultParseWidth: "any"
  }),
  day: se({
    matchPatterns: Io,
    defaultMatchWidth: "wide",
    parsePatterns: No,
    defaultParseWidth: "any"
  }),
  dayPeriod: se({
    matchPatterns: $o,
    defaultMatchWidth: "any",
    parsePatterns: Ro,
    defaultParseWidth: "any"
  })
}, sr = {
  code: "en-US",
  formatDistance: ao,
  formatLong: co,
  formatRelative: fo,
  localize: wo,
  match: Wo,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let _o = {};
function ge() {
  return _o;
}
function Fe(t) {
  const e = b(t), r = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return r.setUTCFullYear(e.getFullYear()), +t - +r;
}
function ko(t, e) {
  const r = b(t), n = b(e), a = r.getTime() - n.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
const fr = 6048e5, Co = 864e5, $t = 6e4, Rt = 525600, Wt = 43200, _t = 1440;
function ct(t, e, r) {
  const n = ge(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? sr, o = ko(t, e);
  if (isNaN(o))
    throw new RangeError("Invalid time value");
  const i = Object.assign({}, r, {
    addSuffix: r == null ? void 0 : r.addSuffix,
    comparison: o
  });
  let c, u;
  o > 0 ? (c = b(e), u = b(t)) : (c = b(t), u = b(e));
  const f = cr((r == null ? void 0 : r.roundingMethod) ?? "round"), s = u.getTime() - c.getTime(), d = s / $t, l = Fe(u) - Fe(c), m = (s - l) / $t, p = r == null ? void 0 : r.unit;
  let y;
  if (p ? y = p : d < 1 ? y = "second" : d < 60 ? y = "minute" : d < _t ? y = "hour" : m < Wt ? y = "day" : m < Rt ? y = "month" : y = "year", y === "second") {
    const v = f(s / 1e3);
    return a.formatDistance("xSeconds", v, i);
  } else if (y === "minute") {
    const v = f(d);
    return a.formatDistance("xMinutes", v, i);
  } else if (y === "hour") {
    const v = f(d / 60);
    return a.formatDistance("xHours", v, i);
  } else if (y === "day") {
    const v = f(m / _t);
    return a.formatDistance("xDays", v, i);
  } else if (y === "month") {
    const v = f(m / Wt);
    return v === 12 && p !== "month" ? a.formatDistance("xYears", 1, i) : a.formatDistance("xMonths", v, i);
  } else {
    const v = f(m / Rt);
    return a.formatDistance("xYears", v, i);
  }
}
function Te(t) {
  const e = b(t);
  return e.setHours(0, 0, 0, 0), e;
}
function Bo(t, e) {
  const r = Te(t), n = Te(e), a = +r - Fe(r), o = +n - Fe(n);
  return Math.round((a - o) / Co);
}
function C(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Yo(t) {
  const e = b(t), r = C(t, 0);
  return r.setFullYear(e.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Lo(t) {
  const e = b(t);
  return Bo(e, Yo(e)) + 1;
}
function ye(t, e) {
  var c, u, f, s;
  const r = ge(), n = (e == null ? void 0 : e.weekStartsOn) ?? ((u = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? r.weekStartsOn ?? ((s = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : s.weekStartsOn) ?? 0, a = b(t), o = a.getDay(), i = (o < n ? 7 : 0) + o - n;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function Ie(t) {
  return ye(t, { weekStartsOn: 1 });
}
function lr(t) {
  const e = b(t), r = e.getFullYear(), n = C(t, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = Ie(n), o = C(t, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Ie(o);
  return e.getTime() >= a.getTime() ? r + 1 : e.getTime() >= i.getTime() ? r : r - 1;
}
function Go(t) {
  const e = lr(t), r = C(t, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), Ie(r);
}
function qo(t) {
  const e = b(t), r = +Ie(e) - +Go(e);
  return Math.round(r / fr) + 1;
}
function dr(t, e) {
  var s, d, l, m;
  const r = b(t), n = r.getFullYear(), a = ge(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((m = (l = a.locale) == null ? void 0 : l.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = C(t, 0);
  i.setFullYear(n + 1, 0, o), i.setHours(0, 0, 0, 0);
  const c = ye(i, e), u = C(t, 0);
  u.setFullYear(n, 0, o), u.setHours(0, 0, 0, 0);
  const f = ye(u, e);
  return r.getTime() >= c.getTime() ? n + 1 : r.getTime() >= f.getTime() ? n : n - 1;
}
function Uo(t, e) {
  var c, u, f, s;
  const r = ge(), n = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((u = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((s = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : s.firstWeekContainsDate) ?? 1, a = dr(t, e), o = C(t, 0);
  return o.setFullYear(a, 0, n), o.setHours(0, 0, 0, 0), ye(o, e);
}
function Ho(t, e) {
  const r = b(t), n = +ye(r, e) - +Uo(r, e);
  return Math.round(n / fr) + 1;
}
function w(t, e) {
  const r = t < 0 ? "-" : "", n = Math.abs(t).toString().padStart(e, "0");
  return r + n;
}
const W = {
  // Year
  y(t, e) {
    const r = t.getFullYear(), n = r > 0 ? r : 1 - r;
    return w(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(t, e) {
    const r = t.getMonth();
    return e === "M" ? String(r + 1) : w(r + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return w(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return w(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return w(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return w(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return w(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const r = e.length, n = t.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return w(a, e.length);
  }
}, J = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, kt = {
  // Era
  G: function(t, e, r) {
    const n = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, r) {
    if (e === "yo") {
      const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return W.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, r, n) {
    const a = dr(t, n), o = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const i = o % 100;
      return w(i, 2);
    }
    return e === "Yo" ? r.ordinalNumber(o, { unit: "year" }) : w(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const r = lr(t);
    return w(r, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const r = t.getFullYear();
    return w(r, e.length);
  },
  // Quarter
  Q: function(t, e, r) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(n);
      case "QQ":
        return w(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, r) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(n);
      case "qq":
        return w(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, r) {
    const n = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return W.M(t, e);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, r) {
    const n = t.getMonth();
    switch (e) {
      case "L":
        return String(n + 1);
      case "LL":
        return w(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, r, n) {
    const a = Ho(t, n);
    return e === "wo" ? r.ordinalNumber(a, { unit: "week" }) : w(a, e.length);
  },
  // ISO week of year
  I: function(t, e, r) {
    const n = qo(t);
    return e === "Io" ? r.ordinalNumber(n, { unit: "week" }) : w(n, e.length);
  },
  // Day of the month
  d: function(t, e, r) {
    return e === "do" ? r.ordinalNumber(t.getDate(), { unit: "date" }) : W.d(t, e);
  },
  // Day of year
  D: function(t, e, r) {
    const n = Lo(t);
    return e === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : w(n, e.length);
  },
  // Day of week
  E: function(t, e, r) {
    const n = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, r, n) {
    const a = t.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return w(o, 2);
      case "eo":
        return r.ordinalNumber(o, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, r, n) {
    const a = t.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return w(o, e.length);
      case "co":
        return r.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, r) {
    const n = t.getDay(), a = n === 0 ? 7 : n;
    switch (e) {
      case "i":
        return String(a);
      case "ii":
        return w(a, e.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, r) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, r) {
    const n = t.getHours();
    let a;
    switch (n === 12 ? a = J.noon : n === 0 ? a = J.midnight : a = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, r) {
    const n = t.getHours();
    let a;
    switch (n >= 17 ? a = J.evening : n >= 12 ? a = J.afternoon : n >= 4 ? a = J.morning : a = J.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, r) {
    if (e === "ho") {
      let n = t.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return W.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, r) {
    return e === "Ho" ? r.ordinalNumber(t.getHours(), { unit: "hour" }) : W.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, r) {
    const n = t.getHours() % 12;
    return e === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : w(n, e.length);
  },
  // Hour [1-24]
  k: function(t, e, r) {
    let n = t.getHours();
    return n === 0 && (n = 24), e === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : w(n, e.length);
  },
  // Minute
  m: function(t, e, r) {
    return e === "mo" ? r.ordinalNumber(t.getMinutes(), { unit: "minute" }) : W.m(t, e);
  },
  // Second
  s: function(t, e, r) {
    return e === "so" ? r.ordinalNumber(t.getSeconds(), { unit: "second" }) : W.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return W.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, r) {
    const n = t.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      case "X":
        return Bt(n);
      case "XXXX":
      case "XX":
        return G(n);
      case "XXXXX":
      case "XXX":
      default:
        return G(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, r) {
    const n = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return Bt(n);
      case "xxxx":
      case "xx":
        return G(n);
      case "xxxxx":
      case "xxx":
      default:
        return G(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, r) {
    const n = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ct(n, ":");
      case "OOOO":
      default:
        return "GMT" + G(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, r) {
    const n = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ct(n, ":");
      case "zzzz":
      default:
        return "GMT" + G(n, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, r) {
    const n = Math.trunc(t.getTime() / 1e3);
    return w(n, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, r) {
    const n = t.getTime();
    return w(n, e.length);
  }
};
function Ct(t, e = "") {
  const r = t > 0 ? "-" : "+", n = Math.abs(t), a = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? r + String(a) : r + String(a) + e + w(o, 2);
}
function Bt(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + w(Math.abs(t) / 60, 2) : G(t, e);
}
function G(t, e = "") {
  const r = t > 0 ? "-" : "+", n = Math.abs(t), a = w(Math.trunc(n / 60), 2), o = w(n % 60, 2);
  return r + a + e + o;
}
const Yt = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, yr = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Qo = (t, e) => {
  const r = t.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return Yt(t, e);
  let o;
  switch (n) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Yt(n, e)).replace("{{time}}", yr(a, e));
}, Vo = {
  p: yr,
  P: Qo
}, jo = /^D+$/, zo = /^Y+$/, Jo = ["D", "DD", "YY", "YYYY"];
function Xo(t) {
  return jo.test(t);
}
function Ko(t) {
  return zo.test(t);
}
function Zo(t, e, r) {
  const n = ei(t, e, r);
  if (console.warn(n), Jo.includes(t)) throw new RangeError(n);
}
function ei(t, e, r) {
  const n = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function ti(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function ri(t) {
  if (!ti(t) && typeof t != "number")
    return !1;
  const e = b(t);
  return !isNaN(Number(e));
}
const ni = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ai = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oi = /^'([^]*?)'?$/, ii = /''/g, ui = /[a-zA-Z]/;
function pe(t, e, r) {
  var s, d, l, m;
  const n = ge(), a = n.locale ?? sr, o = n.firstWeekContainsDate ?? ((d = (s = n.locale) == null ? void 0 : s.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, i = n.weekStartsOn ?? ((m = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : m.weekStartsOn) ?? 0, c = b(t);
  if (!ri(c))
    throw new RangeError("Invalid time value");
  let u = e.match(ai).map((p) => {
    const y = p[0];
    if (y === "p" || y === "P") {
      const v = Vo[y];
      return v(p, a.formatLong);
    }
    return p;
  }).join("").match(ni).map((p) => {
    if (p === "''")
      return { isToken: !1, value: "'" };
    const y = p[0];
    if (y === "'")
      return { isToken: !1, value: ci(p) };
    if (kt[y])
      return { isToken: !0, value: p };
    if (y.match(ui))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + y + "`"
      );
    return { isToken: !1, value: p };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(c, u));
  const f = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return u.map((p) => {
    if (!p.isToken) return p.value;
    const y = p.value;
    (Ko(y) || Xo(y)) && Zo(y, e, String(t));
    const v = kt[y[0]];
    return v(c, y, a.localize, f);
  }).join("");
}
function ci(t) {
  const e = t.match(oi);
  return e ? e[1].replace(ii, "'") : t;
}
function si(t) {
  return b(t).getMonth();
}
function pr(t) {
  return C(t, Date.now());
}
function fi(t, e) {
  const r = Te(t), n = Te(e);
  return +r == +n;
}
function mr(t) {
  return fi(t, pr(t));
}
function li(t, e) {
  const r = b(t), n = b(e);
  return r.getFullYear() === n.getFullYear();
}
function hr(t) {
  return li(t, pr(t));
}
const gi = (t) => {
  const e = /* @__PURE__ */ new Date(), r = new Date(t);
  return mr(r) ? ut(e, r) < 60 ? "just now" : ct(r, e, { addSuffix: !0 }) : hr(r) ? pe(r, "d MMMM, HH:mm") : pe(r, "d MMMM yyyy, HH:mm");
}, vi = (t) => {
  const e = /* @__PURE__ */ new Date(), r = new Date(t);
  return mr(r) ? ut(e, r) < 60 ? "just now" : ct(r, e, { addSuffix: !0 }) : hr(r) ? pe(r, "d MMMM") : pe(r, "d MMMM yyyy");
}, wi = (t) => {
  const e = /* @__PURE__ */ new Date(), r = new Date(t);
  return ut(e, r) < 60 ? "just now" : ct(r, e, { addSuffix: !0 });
}, bi = () => {
  const e = new Intl.DateTimeFormat("en-US", { timeZoneName: "long" }).formatToParts(/* @__PURE__ */ new Date()).find((r) => r.type === "timeZoneName");
  return e ? e.value : "";
}, di = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], Si = (t, e = {}) => {
  if (!t) return "";
  const { includeDay: r = !0, includeTimestamp: n = !1 } = e, a = r ? "d " : "", o = di[si(t)].length <= 3 ? "MMM" : "MMM.";
  return pe(t, `${a}${o} yyyy${n ? " 'at' HH:mm" : ""}`);
};
export {
  bi as IANATimeZoneName,
  Si as formatDateWithShortMonth,
  wi as formatDistanceInWords,
  vi as formatSmartDate,
  gi as formatSmartTimestamp,
  yi as handleError,
  mi as parseURLParams,
  hi as stringifyURLParams,
  pi as trackEvent
};
